<template>
    <ul class="mt-5 p-0 text-xl text-gray-800">
        <li v-for="(answer, index) in value.answers"
            class="w-full border border-gray-300 px-3 py-2 mb-4 cursor-pointer hover:bg-gray-200"
            :class="{'mb-20 md:mb-0' : index == (value.answers.length - 1)}"
            @click="selectAnswer(answer)">

            <div class="flex items-center">
                <div class="text-2xl mr-5">
                    <i v-if="answer.id == value.selected" class="text-green-600 far fa-check-circle"></i>
                    <i v-else class="text-gray-400 fas fa-minus"></i>
                </div>
                <span v-html="answer.answer"></span>
            </div>
        </li>
    </ul>
</template>
<script>
    export default {

        props:{
            value:{
                type: Object,
                required: true,
            }
        },

        methods: {
            selectAnswer(answer) {
                var question = this.value;
                question.selected = answer.id;
                this.$emit('input', question)

                var data = {
                    answer_id: answer.id,
                    question_id: this.value.id,
                }

                var keys = JSON.parse(Storage.get('nlcaa-quiz-app'))

                App.request().put(`/api/quiz/change`, {...data, ...keys}).then(response => {
                    this.$emit('score', response.data.score);
                }).catch(error => {
                    Alert.error(error.response.message)
                })
            }
        }
    }
</script>
